export default {
    namespaced: true,
    state: {
        istDatenUebernahmeMUK: false,
        unternehmensbezeichnung: null,
        zusatzUnternehmensbezeichnung: null,
        land: 'DE',
        strasse: null,
        hausNrUndzusatz: null,
        postleitzahl: null,
        ort: null,
        adresszusatz: null,
    },
    getters: {
        istDatenUebernahmeMUK (state) {
            return state.istDatenUebernahmeMUK
        },
        unternehmensbezeichnung (state) {
            return state.unternehmensbezeichnung
        },
        zusatzUnternehmensbezeichnung (state) {
            return state.zusatzUnternehmensbezeichnung
        },
        land (state) {
            return state.land
        },
        strasse (state) {
            return state.strasse
        },
        hausNrUndzusatz (state) {
            return state.hausNrUndzusatz
        },
        postleitzahl (state) {
            return state.postleitzahl
        },
        ort (state) {
            return state.ort
        },
        adresszusatz (state) {
            return state.adresszusatz
        },

    },
    mutations: {
        reset (state) {
            state.istDatenUebernahmeMUK = false
            state.unternehmensbezeichnung = null
            state.zusatzUnternehmensbezeichnung = null
            state.land = 'DE'
            state.strasse = null
            state.hausNrUndzusatz = null
            state.postleitzahl = null
            state.ort = null
            state.adresszusatz = null
        },
        istDatenUebernahmeMUK (state, istDatenUebernahmeMUK) {
            state.istDatenUebernahmeMUK = istDatenUebernahmeMUK
        },
        unternehmensbezeichnung (state, unternehmensbezeichnung) {
            state.unternehmensbezeichnung = unternehmensbezeichnung
        },
        zusatzUnternehmensbezeichnung (state, zusatzUnternehmensbezeichnung) {
            state.zusatzUnternehmensbezeichnung = zusatzUnternehmensbezeichnung
        },
        land (state, land) {
            state.land = land
        },
        strasse (state, strasse) {
            state.strasse = strasse
        },
        hausNrUndzusatz (state, hausNrUndzusatz) {
            state.hausNrUndzusatz = hausNrUndzusatz
        },
        postleitzahl (state, postleitzahl) {
            state.postleitzahl = postleitzahl
        },
        ort (state, ort) {
            state.ort = ort
        },
        adresszusatz (state, adresszusatz) {
            state.adresszusatz = adresszusatz
        },

    },
    actions: {

    }
}
